import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_oval_circle",
  "use": "icon-home_oval_circle-usage",
  "viewBox": "0 0 223 223",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 223 223\" id=\"icon-home_oval_circle\">\n    <path stroke=\"#fff\" stroke-width=\"2.5\" d=\"M21.773 101.835C-2.83 73.913 26.362 46.827 77.63 45.978c101.908 6.478 124.697 96.69 116.947 116.947-7.751 20.256-30.689 20.862-64.576-20.286-33.888-41.149-77.474-5.901-108.228-40.804z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol